"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const philosophyItems = [{
  problem: "The Fragmentation Trap",
  solution: "Founder burnout is often the result of friction within the machine. We replace fragmented software and manual workarounds with integrated operational systems. By creating a single source of truth, we eliminate the cognitive load of managing disconnected data and silos."
}, {
  problem: "The Reactive Cycle",
  solution: "Moving beyond guesswork requires robust decision architecture. We build reporting infrastructures that turn noise into signal, allowing leadership to lead with foresight and calm confidence rather than constant reaction to the latest crisis."
}, {
  problem: "The Scale Bottleneck",
  solution: "Growth shouldn't mean adding more weight to the founder's shoulders. We implement practical automation and execution frameworks that support expansion without proportional increases in operational friction or personal burnout."
}];
export default function TheStrategicPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="108115" id="our-philosophy" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute top-0 left-4 select-none font-mono text-[12rem] font-bold leading-none tracking-tighter text-primary/5 md:text-[16rem] lg:left-12 lg:text-[20rem]" aria-hidden="true">
        01
      </div>

      <div ref={ref} className={`container relative z-10 mx-auto px-6 transition-all duration-1000 ease-out lg:px-8 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-24">
          {}
          <div className="lg:col-span-5">
            <div className="sticky top-32">
              <h2 className="font-default text-4xl leading-tight tracking-tight md:text-5xl lg:text-6xl text-foreground">
                The Burden of <br className="hidden lg:block" />
                <span className="text-primary">Fragmentation.</span>
              </h2>
              <p className="mt-6 max-w-md text-lg leading-relaxed text-muted-foreground font-default">
                Modern ventures are often held back by the very complexity meant
                to scale them. We architect the operator-led systems that remove 
                friction and restore focus.
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 lg:pt-4">
            <Accordion type="single" collapsible className="w-full space-y-6">
              {philosophyItems.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/20 bg-card/40 data-[state=open]:bg-primary/5 data-[state=open]:border-primary/40 rounded-none border px-6 py-2 transition-colors duration-500">
                  <AccordionTrigger className="font-default text-xl font-medium tracking-tight hover:no-underline lg:text-2xl text-foreground">
                    {item.problem}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground font-default text-base leading-relaxed md:text-lg md:leading-loose pb-6 pt-2">
                    {item.solution}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}